var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": _vm.minWidth,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "div",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.modalIconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(_vm.modalHeader))]),
              ]
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _vm.isActive &&
              !_vm.isExportTextModalActive &&
              !_vm.isEmailModalActive &&
              !_vm.sendEmailMode
                ? _c("div", [
                    _c("div", { staticClass: "field" }, [
                      _c("span", [_vm._v("Select export type")]),
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-default p-round p-bigger p-smooth",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.exportType,
                                expression: "exportType",
                              },
                            ],
                            attrs: { type: "radio", id: "text", value: "text" },
                            domProps: {
                              checked: _vm._q(_vm.exportType, "text"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.exportType = "text"
                              },
                            },
                          }),
                          _c("div", { staticClass: "state p-primary-o" }, [
                            _c("label", [_vm._v("Email Text")]),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-default p-round p-bigger p-smooth",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.exportType,
                                expression: "exportType",
                              },
                            ],
                            attrs: {
                              type: "radio",
                              disabled: _vm.value.subQuoteNo !== 0,
                              id: "text",
                              value: "arnie",
                            },
                            domProps: {
                              checked: _vm._q(_vm.exportType, "arnie"),
                            },
                            on: {
                              change: function ($event) {
                                _vm.exportType = "arnie"
                              },
                            },
                          }),
                          _c("div", { staticClass: "state p-primary-o" }, [
                            _c("label", [_vm._v("Arnie")]),
                          ]),
                        ]
                      ),
                      _vm.value.subQuoteNo !== 0
                        ? _c("div", { staticClass: "pretty" }, [
                            _c("span", { staticClass: "has-text-danger" }, [
                              _vm._v(
                                "Please go to main quote to send to ARNIE"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ])
                : _vm._e(),
              _vm.isExportTextModalActive
                ? _c("quote-export-text", {
                    ref: "exporttext",
                    attrs: { active: _vm.isExportTextModalActive },
                    on: {
                      "update:active": function ($event) {
                        _vm.isExportTextModalActive = $event
                      },
                      "generate-text-email": _vm.generateTextEmail,
                    },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  })
                : _vm._e(),
              _vm.isEmailModalActive
                ? _c("vue-email", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isImageAttachActive,
                        expression: "!isImageAttachActive",
                      },
                    ],
                    ref: "emailer",
                    attrs: {
                      "report-bytes": _vm.reportBytes,
                      "report-name": `${_vm.emailer.reportName}.${_vm.reportExtension}`,
                      "report-content-type": _vm.reportContentType,
                      "quote-image-attachments": _vm.selectedImages,
                      "asset-id": _vm.emailer.assetId,
                    },
                    on: { "new-email": _vm.newEmailInput, sent: _vm.sent },
                    model: {
                      value: _vm.emailer,
                      callback: function ($$v) {
                        _vm.emailer = $$v
                      },
                      expression: "emailer",
                    },
                  })
                : _vm._e(),
              _vm.emailer && _vm.isImageAttachActive
                ? _c("image-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isImageAttachActive,
                        expression: "isImageAttachActive",
                      },
                    ],
                    attrs: {
                      "quote-id": _vm.emailer.assetId,
                      "sub-quote-nos": _vm.value.subQuoteNos,
                      "quote-ids": _vm.value.subQuoteNos.map((q) => q.value),
                      "pre-select": "NotSent",
                    },
                    model: {
                      value: _vm.selectedImages,
                      callback: function ($$v) {
                        _vm.selectedImages = $$v
                      },
                      expression: "selectedImages",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "footer",
            {
              staticClass: "modal-card-foot",
              style: `justify-content: flex-${_vm.buttonLocation}`,
            },
            [
              _vm.isActive &&
              !_vm.isExportTextModalActive &&
              !_vm.isEmailModalActive
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "button is-success tooltip",
                        attrs: { "data-tooltip": "Export" },
                        on: {
                          click: function ($event) {
                            return _vm.exportQuote()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", {
                            staticClass: "mdi mdi-file-export mdi-18px",
                          }),
                        ]),
                        _c("span", [_vm._v("Export")]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button tooltip",
                        attrs: { "data-tooltip": "Close" },
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      },
                      [_vm._v("Close")]
                    ),
                  ])
                : _vm._e(),
              _vm.isExportTextModalActive
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "button is-success tooltip",
                        attrs: { "data-tooltip": "Email Text Quote" },
                        on: {
                          click: function ($event) {
                            return _vm.ok()
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon is-small" }, [
                          _c("i", { staticClass: "mdi mdi-18px mdi-send" }),
                        ]),
                        _c("span", [_vm._v("Ok")]),
                      ]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button tooltip",
                        attrs: { "data-tooltip": "Close" },
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      },
                      [_vm._v("Close")]
                    ),
                  ])
                : _vm._e(),
              _vm.isEmailModalActive
                ? _c("div", [
                    _c("div", { staticStyle: { "align-self": "flex-start" } }, [
                      false
                        ? _c(
                            "button",
                            {
                              staticClass: "button tooltip is-tooltip-topleft",
                              attrs: { "data-tooltip": "Attach media" },
                              on: {
                                click: function ($event) {
                                  return _vm.attach()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "icon" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-paperclip mdi-18px",
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _c("div", { staticStyle: { "align-self": "flex-end" } }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-primary tooltip is-tooltip-topright",
                          attrs: {
                            "data-tooltip": "Send Email",
                            disabled: !_vm.enableSend,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.send()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-send mdi-18px" }),
                          ]),
                          _c("span", [_vm._v("Send")]),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.enableAttach,
                              expression: "enableAttach",
                            },
                          ],
                          staticClass: "button is-primary tooltip",
                          attrs: {
                            "data-tooltip": [
                              !_vm.toggleAttachButton
                                ? "Attach images"
                                : "Done",
                            ],
                            disabled: !_vm.enableAttach,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showAttachImage()
                            },
                          },
                        },
                        [
                          !_vm.toggleAttachButton
                            ? _c("span", { staticClass: "icon is-small" }, [
                                _c("i", {
                                  staticClass: "mdi mdi-18px mdi-paperclip",
                                }),
                              ])
                            : _c("span", [_vm._v("Done")]),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button tooltip is-tooltip-topright",
                          attrs: { "data-tooltip": "Discard Email" },
                          on: {
                            click: function ($event) {
                              return _vm.discardEmail()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-delete mdi-18px" }),
                          ]),
                        ]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }